import MapView from "@arcgis/core/views/MapView";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import { trackEvent } from "../../hooks/useAnalytics";

export default function BasemapSwitcher(view: MapView) {
	const toggle = new BasemapToggle({
		view: view,
		nextBasemap: "satellite",
	});
	toggle.on("toggle", (event) => {
		//console.log("Basemap changed to:", event.current.title);
		trackEvent('basemap_toggle', event.current.title);
	});

	return toggle;
}
